export default "__VITE_ASSET__30e40aa1__"